// extracted by mini-css-extract-plugin
export default {"__hero_banner":"styles___hero_banner__RgMmh","__details":"styles___details__vMjRQ","__para":"styles___para__1mDw+","__scroll_to_section":"styles___scroll_to_section__WE7ff"};